export default {
    heading: 'Ancillary services type - Select at least one',
    add_test: 'Add another test',
    enter_test: 'Enter test',
    test_name: 'Test name',
    location: 'Location',
    available_at: 'Available at',
    filter_label: 'Start typing...',
    no_tests_available: 'Currently, chosen practice does not provide any tests. Please choose another ancillary service.',
    selected_tests: 'Selected Tests',
    selected_service: 'Selected Service',
}
